import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"

/**
 * Loading skeleton assess demand device summary pages
 */
const AssessDemandDeviceSkeleton = (): ReactElement => (
    <Stack spacing={GRID_SPACING} justifyContent="flex-start" height="100%">
        <AppSkeleton height="140px" variant="rectangular" />
        <Stack
            spacing={GRID_SPACING}
            direction={{ xs: "column", md: "row" }}
            height="100%"
        >
            <AppSkeleton width="50%" height="100%" variant="rectangular" />
            <AppSkeleton width="50%" height="100%" variant="rectangular" />
        </Stack>
    </Stack>
)
export default AssessDemandDeviceSkeleton
